import React from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import "../../../../styles/Pages/Setting/Profile/FeeSetup/FeeSetup.style.css";
import OneTimeFeeMainScreen from "../../../../components/PagesComponents/Setting/Profile/FeeSetup/OneTimeFee/OneTimeFeeMainScreen.component";
import SubscriptionBasedMainScreen from "../../../../components/PagesComponents/Setting/Profile/FeeSetup/SubscriptionFee/SubscriptionBasedMainScreen.component";
const Body = ({ currentComponent, setCurrentComponent }) => {
  return (
    <div className="flex-col align-left justify-start g-1 w-full">
      <Helmet>
        <title>Setup-Fee</title>
      </Helmet>
      <PageHeader title={"Fees section set up"} />
      <div className="flex-col align-left justify-start g-1 w-full radius-6 back-white pt-1 overflow-hide">
        <h3 className="poppins-medium weight-500 t-16 color-grayColor pl-2">
          Click any fees type
        </h3>
        <div className="flex-row align-center justify-center w-full">
          <div className="feeCollectionComponentChangeBtn">
            <input
              type="radio"
              value={"1"}
              checked={currentComponent.toString() === "1"}
              onChange={(e) => setCurrentComponent(e.target.value)}
              name="feeSetupPageChangeBtnInputName"
            />
            <span>One time enrollment fees (yearly)</span>
          </div>
          <div className="feeCollectionComponentChangeBtn">
            <input
              type="radio"
              value={"2"}
              checked={currentComponent.toString() === "2"}
              onChange={(e) => setCurrentComponent(e.target.value)}
              name="feeSetupPageChangeBtnInputName"
            />
            <span>Subscription fees (monthly/semester)</span>
          </div>
        </div>
      </div>

      <div className="w-full flex-row align-left justify-start scroll-x">
        {currentComponent.toString() === "1" ? (
          <OneTimeFeeMainScreen />
        ) : (
          <SubscriptionBasedMainScreen />
        )}
      </div>
    </div>
  );
};

export default Body;
